// extracted by mini-css-extract-plugin
export default {"what":"WhatWeDo_what__K-CN9","desc":"WhatWeDo_desc__kdet4","wrapper":"WhatWeDo_wrapper__hnjdW","divider":"WhatWeDo_divider__jhVhD"};